// PWA wiring: manifest + icon links (kept out of index.html so Bun's bundler
// doesn't try to resolve them) and the service worker registration.

const links: Array<Record<string, string>> = [
  { rel: "manifest", href: "/manifest.webmanifest" },
  { rel: "icon", href: "/icon.svg", type: "image/svg+xml" },
  { rel: "icon", href: "/icons/icon-192.png", type: "image/png", sizes: "192x192" },
  { rel: "apple-touch-icon", href: "/icons/apple-touch-icon.png" },
];

for (const attrs of links) {
  const el = document.createElement("link");
  for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
  document.head.appendChild(el);
}

// Android/desktop Chrome: hold on to the install prompt so the launcher can
// offer an "Install app" button instead of relying on the browser menu.
export type InstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};
export let installPrompt: InstallPromptEvent | null = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  installPrompt = e as InstallPromptEvent;
  window.dispatchEvent(new Event("pwa-installable"));
});
window.addEventListener("appinstalled", () => {
  installPrompt = null;
  window.dispatchEvent(new Event("pwa-installable"));
});

// Register the service worker in production only — in dev it would fight hot
// reloading by serving cached bundles.
const isLocal = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
if ("serviceWorker" in navigator && !isLocal) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
